import { colors } from '@/constants/colors'
import { BaseToast, ErrorToast } from 'react-native-toast-message'
import type { BaseToastProps } from 'react-native-toast-message'

const toastConfig = {
	success: (props: BaseToastProps) => (
		<BaseToast
			{...props}
			style={{
				width: '100%',
				borderRadius: 0,
				height: 80,
				borderLeftColor: colors.palette_10,
			}}
			contentContainerStyle={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: colors.palette_10,
			}}
			text1Style={{
				textAlign: 'center',
				fontSize: 18,
				color: colors.palette_6,
				fontFamily: 'MaisonNeue-Medium',
			}}
			text2Style={{
				textAlign: 'center',
				fontSize: 14,
				color: colors.palette_6,
				fontFamily: 'MaisonNeue-Medium',
			}}
			text2NumberOfLines={3}
		/>
	),
	error: (props: BaseToastProps) => (
		<ErrorToast
			{...props}
			style={{
				width: '100%',
				borderLeftColor: colors.palette_9,
				borderRadius: 0,
				height: 80,
			}}
			contentContainerStyle={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: colors.palette_9,
			}}
			text1Style={{
				textAlign: 'center',
				fontSize: 16,
				color: colors.palette_6,
				fontFamily: 'MaisonNeue-Medium',
			}}
			text2Style={{
				textAlign: 'center',
				fontSize: 14,
				color: colors.palette_6,
				fontFamily: 'MaisonNeue-Medium',
			}}
			text1NumberOfLines={3}
			text2NumberOfLines={3}
		/>
	),
}

export default toastConfig
